import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { TOASTR_CNST } from '../constants/spinner_config.cnst';
import { isNullOrUndefined } from 'shared-library';

@Injectable({
  providedIn: 'root',
})
export class MatTosterService {
  horizontalPosition: MatSnackBarHorizontalPosition = 'end'; // Position the toast at the right
  verticalPosition: MatSnackBarVerticalPosition = 'top'; // Position the toast at the top

  constructor(private snackBar: MatSnackBar,
    private toastr: ToastrService
    ) {}

  showSuccess(message: string, duration: number = 2000) {
    this.snackBar.open(message, 'Close', {
      duration,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: ['mat-snack-bar-container-success'], // Use a default class for positioning
    });
  }

  showError(message: string, duration: number = 2000) {
    this.snackBar.open(message, 'Close', {
      duration,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: ['mat-snack-bar-container-error'], // Use a default class for positioning
    });
  }
  showToastMessage(message: string, type: string, options?: any): void {
    let toastOptions: any = TOASTR_CNST;
    if (!isNullOrUndefined(options)) {
      toastOptions = { ...TOASTR_CNST, ...options.options };
    }
    this.toastr.clear();
    (this.toastr[type as keyof typeof this.toastr] as any)(message, toastOptions.title, toastOptions);
  }
}
